import {queryOptions} from '@tanstack/react-query';

import {getHotelContent} from '@/api/bffSupport';

export const singleHotel = (hotelId: string) => {
  return queryOptions({
    queryKey: ['bff-support', 'single-hotel', hotelId],
    queryFn: async ({signal}) => {
      const response = await getHotelContent(
        {hotel: hotelId},
        {
          signal,
        }
      );
      if (response.status !== 200) {
        throw new Error(`Failed to fetch hotel content for ${hotelId}`);
      }

      return response.data;
    },
  });
};
